import { render, staticRenderFns } from "./instrumentStratIndicatorsRenderer.vue?vue&type=template&id=00be94e4&"
import script from "./instrumentStratIndicatorsRenderer.vue?vue&type=script&lang=js&"
export * from "./instrumentStratIndicatorsRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports